import { Device } from 'DeviceUtils';
import ClearCache from './ClearCache';
import ClearCacheTablet from './ClearCache.tablet';

export default Device.isTabletOrWeb ? ClearCacheTablet : ClearCache;
